export default function getEnv(envName: string) {
  if (process.env.NODE_ENV === "development") {
    return process.env[envName];
  }
  // @ts-ignore
  return window.prod_env[envName];
}
